import React, { Component } from "react";
import { connect } from "react-redux";
import { signUpStatusReasons } from "../../actions/signUpActions";
import { Typography, CircularProgress } from "@material-ui/core";
import { requestState } from "../../actions/utils";

class SignUpStatus extends Component {

    render() {
        const { reason, status, email } = this.props;
        if ( status === requestState.inProgress ) {
            return <CircularProgress color="primary"/>
        }
        switch (reason.code ) {
            case signUpStatusReasons.passMismatch.code:
                return (
                    <Typography
                        variant="subtitle1"
                        color="error"
                        align="center"
                    >
                        {signUpStatusReasons.passMismatch.text}
                    </Typography>
                );
            case signUpStatusReasons.emailRegistered.code:
                return (
                    <Typography
                        variant="subtitle1"
                        color="error"
                        align="center"
                    >
                        {signUpStatusReasons.emailRegistered.text}
                    </Typography>
                );
            case signUpStatusReasons.success.code:
                return (
                    <Typography
                        variant="subtitle1"
                        color="#0EC362"
                        align="center"
                    >
                        {email ? `Verification code sent to "${email}"` : "Verification code sent"}
                    </Typography>
                );
            default: return null;
        }
    }

}

function mapStateToProps( state, ownProps ) {
    return {
        reason: state.signUp.reason,
        status: state.signUp.status,
        email: state.signUp.email
    }
}

export default connect(
    mapStateToProps
)( SignUpStatus );